import React, { useContext } from 'react'
import { Item, ItemGif, ItemText } from './sc'
import { CollectionStyleContext } from './../context/collection-style-context'

type Props = {
    displayName: string
    backgroundText: string | undefined
    onClick: () => void
}

const AddToButton = ({ displayName, onClick, backgroundText }: Props) => {
    const { itemWidth } = useContext(CollectionStyleContext)

    return displayName ? (
        <Item onClick={onClick} gutter itemWidth={itemWidth}>
            <ItemGif src="https://media.giphy.com/media/fTytsfKCVyb6lB75jM/giphy.gif" alt="New collection" />
            <ItemText background={backgroundText || ''}>{displayName}</ItemText>
        </Item>
    ) : null
}

export default AddToButton
